import React, {
  ReactElement,
  Component,
  useContext,
  useState,
  Fragment,
  useCallback, useEffect, useMemo
} from 'react';
import "./backup-protocol.less";
import marked from "marked";
import {injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {Col, Checkbox, Row, Button} from "antd";
import {LangContext} from '../../../contexts/lang';
import backup_protocol from './protocol-list';
import {IUserInfoType, UserInfoContext} from '../../../contexts/user-info';
import {ShowProtocolContext} from '../contexts/show-protocol';

export interface storage_type {
  name: string,
  storage_type: string,
}

const BackupProtocol: React.FC = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> => {
  const {intl} = useMemo(()=> props, [props]),
    {formatMessage} = useMemo(()=> intl, [intl]),
    user_info: IUserInfoType = useContext(UserInfoContext)[0],
    [is_accept, set_is_accept]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useState<boolean>(false),
    [show_protocol, set_show_protocol]: [boolean, React.Dispatch<React.SetStateAction<boolean>>] = useContext(ShowProtocolContext),
    lang: string = useContext(LangContext)[0],
    confirm_accept = useCallback(async () => {
      const body = {
          cookieInfo: {
            backup: "accept"
          }
        },
        submit_res: any = await fetch(`/serviceHub/v2/user/${user_info.id}/info`, {
          credentials: 'include',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(body)
        });
      if (submit_res.status === 201) {
        set_show_protocol(false);
        sessionStorage.setItem("accept_backup", JSON.stringify({
          userId: user_info?.id,
          accept: true
        }));
      }
      // eslint-disable-next-line
    }, [user_info.id]);

  useEffect(()=>{
    if(!show_protocol) set_is_accept(false)
  }, [show_protocol]);

  return <Fragment>
    {show_protocol && <Col className="backup-protocol">
      <Col className="content-container">
        <Row className="title">{formatMessage({id: "protocol_title"})}</Row>
        <Row className="label">{formatMessage({id: "protocol_label"})}</Row>
        <Col className={`${lang === "en-US" ? "en-cell" : ""} content-cell`}>
          <p
            dangerouslySetInnerHTML={{
              __html: marked(backup_protocol?.[lang === "zh-CN" ? "zh-CN" : lang === "zh-TW" ? "zh-TW" : "en-US"])
            }}
          />
          <Checkbox
            className="mt-5"
            onChange={(e: any) => {
              set_is_accept(e.target.checked)
            }}>
            {formatMessage({id: "i_agree"})}
          </Checkbox>
          <Row className="mt-5" justify="end">
            <Button
              type="primary"
              className="mr-10"
              disabled={!is_accept}
              onClick={confirm_accept}>{formatMessage({id: "confirm"})}</Button>
            <Button onClick={() => {
              set_show_protocol(false);
              props.history.push("/instance-list")
            }}>{formatMessage({id: "cancel"})}</Button>
          </Row>
        </Col>
      </Col>
    </Col>}
  </Fragment>
};

export default injectIntl(withRouter(BackupProtocol) as any);
